import { render } from "./DeveloperItemTinyTable.vue?vue&type=template&id=68c8e7dc"
import script from "./DeveloperItemTinyTable.vue?vue&type=script&lang=js"
export * from "./DeveloperItemTinyTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__